// 全局存储当前弹窗的产品数据
let currentProductData = null;


console.groupEnd();

// 颜色标签列表
const COLOR_LABELS = ['color', 'farve', 'farbe', 'couleur', 'cor', 'colour'];

/**
 * 打开全局弹窗并填充产品数据
 * @param {Object} productData - 产品数据对象
 * @param {string} productData.id - 产品ID
 * @param {string} productData.title - 产品标题
 * @param {string} productData.url - 产品URL
 * @param {Array} productData.variants - 产品变体数组
 * @param {Array} productData.options - 产品选项数组
 * @param {string} productData.featuredImage - 产品特色图片URL
 */
function openGlobalPopup(productData) {
  if (!productData) {
    console.error('No product data provided');
    return;
  }

  // 保存当前产品数据
  currentProductData = productData;

  const popup = document.getElementById('global-popup-overlay');
  if (!popup) {
    console.error('Global popup not found');
    return;
  }

  // 更新产品标题
  const titleElement = popup.querySelector('.product-title');
  if (titleElement) {
    titleElement.textContent = productData.title || '';
  }

  // 渲染产品选项
  renderProductOptions(productData);

  // 保存当前滚动位置
  const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

  // 显示弹窗
  popup.style.display = 'flex';
  document.body.classList.add('popup-open');

  // 若 STL modal 已开启，透明遮罩并将 STL dialog 上推
  const stlModal = document.querySelector('[data-shop-the-look-modal]:not([hidden])');
  if (stlModal) {
    popup.classList.add('in-stl-context');
    const stlDialog = stlModal.querySelector('.shop-the-look-modal__dialog');
    if (stlDialog) {
      // 等两帧确保 popup 内容已渲染并可测量高度
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const popupContent = popup.querySelector('.popup-content');
          const popupHeight = popupContent ? popupContent.offsetHeight : 0;
          if (popupHeight > 0) {
            stlDialog.style.transform = `translateY(-${popupHeight}px)`;
          }
        });
      });
    }
  } else {
    popup.classList.remove('in-stl-context');
  }

  // 恢复滚动位置
  requestAnimationFrame(() => {
    window.scrollTo({
      top: scrollPosition,
      behavior: 'auto',
    });
  });
}

/**
 * 渲染产品选项
 * @param {Object} productData
 * @param {Element} [targetContainer] 可选，指定渲染目标容器；默认使用全局 popup 容器
 */
function renderProductOptions(productData, targetContainer) {
  const container = targetContainer || document.querySelector('#global-popup-overlay .popup-options-container');
  if (!container) return;

  // 清空容器
  container.innerHTML = '';

  if (!productData.options || !productData.variants) {
    container.innerHTML = '<p class="text-center text-white">No options available</p>';
    return;
  }

  // 解析选项和值
  const optionsWithValues = parseOptionsWithValues(productData);

  // 渲染每个选项
  optionsWithValues.forEach((option, optionIndex) => {
    const isColorOption = isColorLabel(option.name);
    const optionDiv = createOptionElement(option, optionIndex, isColorOption, productData);
    container.appendChild(optionDiv);
  });
}

/**
 * 解析产品选项和值
 */
function parseOptionsWithValues(productData) {
  const { options, variants } = productData;
  
  // 创建选项对象数组
  const optionsWithValues = options.map((optionName, index) => {
    const values = new Set();
    const valuesWithAvailability = [];

    // 遍历所有变体，收集该选项的所有值
    variants.forEach(variant => {
      const value = variant.options[index];
      if (value && !values.has(value)) {
        values.add(value);
        valuesWithAvailability.push({
          value: value,
          available: variant.available,
          variant: variant
        });
      }
    });

    return {
      name: optionName,
      position: index + 1,
      values: valuesWithAvailability
    };
  });

  return optionsWithValues;
}

/**
 * 检查是否是颜色标签
 */
function isColorLabel(optionName) {
  const lowerName = optionName.toLowerCase();
  return COLOR_LABELS.some(label => lowerName.includes(label));
}

/**
 * 创建选项元素
 */
function createOptionElement(option, optionIndex, isColorOption, productData) {
  const optionDiv = document.createElement('div');
  optionDiv.className = `js product-form__input product-form__input--pill p-0 flex justify-start gap-x-[25px] w-full items-center ${
    isColorOption ? 'product-form__input--color' : 'product-form__input--size'
  }`;

  // 创建标签
  const label = document.createElement('span');
  label.className = 'form__label text-xs md:text-sm font-normal tracking-[1.2px] md:tracking-[1.4px] whitespace-nowrap ';
  // 颜色选项初始显示第一个可选值的名称
  if (isColorOption) {
    const firstAvailable = option.values.find(v => v.available) || option.values[0];
    label.textContent = firstAvailable ? `${option.name}: ${firstAvailable.value}` : `${option.name}:`;
  } else {
    label.textContent = `${option.name}:`;
  }
  optionDiv.appendChild(label);

  // 创建值容器
  const valuesContainer = document.createElement('div');
  valuesContainer.className = 'flex gap-[25px] w-full flex-wrap';

  // 渲染每个值
  option.values.forEach((valueObj, valueIndex) => {
    if (isColorOption) {
      console.log('>>>>>>>>>>>createColorOption');
      const colorElement = createColorOption(option, valueObj, valueIndex, optionIndex, productData);
      valuesContainer.appendChild(colorElement);
    } else {
      const sizeElement = createSizeOption(option, valueObj, valueIndex, optionIndex, productData);
      valuesContainer.appendChild(sizeElement);
    }
  });

  optionDiv.appendChild(valuesContainer);
  return optionDiv;
}

/**
 * 创建颜色选项
 */
function createColorOption(option, valueObj, valueIndex, optionIndex, productData) {
  const wrapper = document.createElement('div');
  wrapper.className = 'color-option-wrapper';

  const inputId = `global-popup-${productData.id}-${option.position}-${valueIndex}`;
  const inputName = `${option.name}-${option.position}`;

  // 创建radio input
  const input = document.createElement('input');
  input.type = 'radio';
  input.id = inputId;
  input.name = inputName;
  input.value = valueObj.value;
  input.dataset.optionValue = valueObj.value;
  input.dataset.optionPosition = option.position;

  // 第一个可用选项设为选中
  const isFirstAvailable = valueIndex === 0 && valueObj.available;
  if (isFirstAvailable) {
    input.checked = true;
  }

  if (!valueObj.available) {
    input.disabled = true;
    input.classList.add('disabled');
  }

  // 选中时更新选项标签文字
  input.addEventListener('change', function () {
    const parentOptionDiv = this.closest('.product-form__input--color');
    if (parentOptionDiv) {
      const optionLabel = parentOptionDiv.querySelector('.form__label');
      if (optionLabel) {
        optionLabel.textContent = `${option.name}: ${valueObj.value}`;
      }
    }
  });

  wrapper.appendChild(input);

  // 创建label（色块）
  const label = document.createElement('label');
  label.className = `w-6 h-6 border-1 border-solid border-[#2A2A2A] cursor-pointer color-swatch flex items-center justify-center ${
    !valueObj.available ? 'disabled' : ''
  }`;
  label.htmlFor = inputId;

  // 从预处理的颜色数据中获取颜色信息
  const colorData = getColorDataFromSwatches(valueObj.value, productData.colorSwatches);
  
  // 调试：显示详细颜色信息
  const swatch = productData.colorSwatches.find(s => s.name === valueObj.value);

  if (colorData.color) {
    label.style.backgroundColor = colorData.color;
  } else if (colorData.image) {
    const img = document.createElement('img');
    img.src = colorData.image;
    img.alt = valueObj.value;
    img.className = 'w-full h-full object-cover';
    label.appendChild(img);
  }

  wrapper.appendChild(label);
  return wrapper;
}

/**
 * 创建尺寸选项
 */
function createSizeOption(option, valueObj, valueIndex, optionIndex, productData) {
  // 创建表单
  const form = document.createElement('form');
  form.className = 'form';
  form.dataset.type = 'add-to-cart-form';
  form.dataset.productId = productData.id;
  form.addEventListener('submit', handleSizeOptionSubmit);

  // 创建隐藏的variant ID输入框
  const variantInput = document.createElement('input');
  variantInput.type = 'hidden';
  variantInput.name = 'id';
  variantInput.className = 'product-variant-id';
  variantInput.dataset.sizeValue = valueObj.value;
  variantInput.dataset.optionPosition = option.position;
  form.appendChild(variantInput);

  // 创建按钮
  const button = document.createElement('button');
  button.type = 'submit';
  button.name = 'add';
  const availableClass = valueObj.available
    ? 'bg-[#222] cursor-pointer'
    : 'bg-[#C0C0C0] cursor-not-allowed disabled';
  button.className = `size-option-btn product-form__submit ${availableClass} text-white text-xs font-normal tracking-[1.2px] uppercase flex justify-center items-center rounded-sm px-4 py-2 border-none min-w-[60px]`;

  if (!valueObj.available) {
    button.disabled = true;
  }

  // 创建按钮内容
  const span = document.createElement('span');
  span.textContent = valueObj.value;
  button.appendChild(span);

  // 创建加载动画
  const spinner = document.createElement('svg');
  spinner.className = 'spinner hidden animate-spin -ml-1 mr-2 h-4 w-4 text-white';
  spinner.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  spinner.setAttribute('fill', 'none');
  spinner.setAttribute('viewBox', '0 0 24 24');
  spinner.innerHTML = `
    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
  `;
  button.appendChild(spinner);

  form.appendChild(button);
  return form;
}

/**
 * 从预处理的swatch数据中获取颜色信息
 */
function getColorDataFromSwatches(colorValue, swatches) {
  if (!swatches || !Array.isArray(swatches)) {
    return {};
  }

  // 查找匹配的颜色
  const swatch = swatches.find(s => s.name === colorValue);
  if (swatch) {
    let finalColor = swatch.color || '';
    
    // 如果metaobject颜色是黑色或无效，尝试使用swatch的原始颜色
    if (finalColor === '#000000' || finalColor === '#000' || finalColor === 'black' || finalColor === '') {
      const debug = swatch.debug;
      console.log(`🎨 COLOR FALLBACK DEBUG - Checking fallback for ${colorValue}:`, {
        finalColor,
        raw_swatch_hex: debug?.raw_swatch_hex,
        raw_swatch_rgb: debug?.raw_swatch_rgb,
        raw_swatch_color: debug?.raw_swatch_color
      });
      if (debug) {
        // 优先使用原始swatch的hex颜色
        if (debug.raw_swatch_hex && debug.raw_swatch_hex !== '' && debug.raw_swatch_hex !== '#000000' && !debug.raw_swatch_hex.startsWith('rgb_')) {
          finalColor = '#' + debug.raw_swatch_hex;
          console.log(`🎨 COLOR FALLBACK - Using swatch hex: ${finalColor} for ${colorValue}`);
        }
        // 如果hex是RGB格式，从RGB构建颜色
        else if (debug.raw_swatch_hex && debug.raw_swatch_hex.startsWith('rgb_')) {
          const rgbString = debug.raw_swatch_hex.replace('rgb_', '');
          // 处理空格分隔的RGB值
          const rgbValues = rgbString.split(/\s+/).map(v => parseInt(v.trim()));
          if (rgbValues.length === 3 && !rgbValues.some(v => isNaN(v))) {
            finalColor = `rgb(${rgbValues.join(', ')})`;
            console.log(`🎨 COLOR FALLBACK - Using swatch RGB: ${finalColor} for ${colorValue}`);
          }
        }
        // 如果没有hex，尝试从RGB构建颜色
        else if (debug.raw_swatch_rgb && debug.raw_swatch_rgb !== '') {
          // 处理逗号或空格分隔的RGB值
          const rgbValues = debug.raw_swatch_rgb.split(/[,\s]+/).map(v => parseInt(v.trim()));
          if (rgbValues.length === 3 && !rgbValues.some(v => isNaN(v))) {
            finalColor = `rgb(${rgbValues.join(', ')})`;
            console.log(`🎨 COLOR FALLBACK - Using swatch RGB: ${finalColor} for ${colorValue}`);
          }
        }
        // 最后尝试使用原始swatch颜色
        else if (debug.raw_swatch_color && debug.raw_swatch_color !== '' && debug.raw_swatch_color !== '#000000') {
          finalColor = debug.raw_swatch_color;
          console.log(`🎨 COLOR FALLBACK - Using raw swatch color: ${finalColor} for ${colorValue}`);
        }
      }
    }
    
    return {
      color: finalColor,
      image: swatch.image || ''
    };
  }

  return {};
}

/**
 * 处理尺寸选项提交
 */
function handleSizeOptionSubmit(e) {
    e.preventDefault();

  if (!currentProductData) {
    showNotification('Product data not found', 'error');
    return;
  }

    const form = e.target;
  const button = form.querySelector('.size-option-btn');

    // 检查按钮是否被禁用
  if (button && (button.disabled || button.classList.contains('disabled'))) {
      return false;
    }

    // 获取选中的颜色值
  const selectedColorInput = document.querySelector('#global-popup-overlay input[type="radio"]:checked');
    const selectedColor = selectedColorInput ? selectedColorInput.value : null;

    // 获取当前尺寸值
  const sizeValue = form.querySelector('.product-variant-id').dataset.sizeValue;

  // 找到对应的variant ID
  const variantId = findVariantIdByOptions(currentProductData, selectedColor, sizeValue);

    if (!variantId) {
    showNotification('无法找到对应的产品规格', 'error');
      return;
    }

    // 显示loading状态
  button.classList.add('loading');
    button.disabled = true;

  // 添加到购物车
  addToCart(variantId, button, currentProductData);
}

/**
 * 根据选项查找variant ID
 */
function findVariantIdByOptions(productData, colorValue, sizeValue) {
  const { variants, options } = productData;

  if (!variants || !options) return null;

  // 找到颜色和尺寸选项的索引
  const colorIndex = options.findIndex(opt => isColorLabel(opt));
  const sizeIndex = options.findIndex(opt => {
    const lower = opt.toLowerCase();
    return lower.includes('size') || lower.includes('taille');
  });

  // 查找匹配的variant
  const variant = variants.find(v => {
    const opts = v.options || [];
    const colorOk = colorIndex === -1 || !colorValue || opts[colorIndex] === colorValue;
    const sizeOk = sizeIndex === -1 || !sizeValue || opts[sizeIndex] === sizeValue;
    return colorOk && sizeOk;
  });

  return variant ? variant.id : null;
}

/**
 * 添加到购物车
 */
function addToCart(variantId, button, productData) {
    const requestData = {
    id: variantId,
      quantity: 1,
    };

  // 获取购物车组件
  const cartComponent = document.querySelector('alp-cart-toast') || document.querySelector('cart-drawer');
    if (cartComponent && cartComponent.getSectionsToRender) {
    requestData.sections = cartComponent.getSectionsToRender().map(section => section.id);
      requestData.sections_url = window.location.pathname;
    }

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
      headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(requestData),
    })
    .then(response => response.json())
    .then(data => {
        if (data.status && data.status !== 200) {
        throw new Error(data.description || '添加到购物车失败');
        }

      // 发布购物车更新事件
        if (window.publish && window.PUB_SUB_EVENTS) {
        const startMarker = typeof CartPerformance !== 'undefined' 
          ? CartPerformance.createStartingMarker('add:wait-for-subscribers')
          : null;

          publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
            productVariantId: variantId,
            cartData: data,
          }).then(() => {
          if (startMarker && typeof CartPerformance !== 'undefined') {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          }
        });
      }

      // 显示购物车提示
      showCartToast(data, productData);

      // 关闭弹窗
      closeGlobalPopup();
    })
    .catch(error => {
      console.error('Add to cart failed:', error);
      showNotification(error.message || 'Add to cart failed', 'error');
    })
    .finally(() => {
      // 移除loading状态
      button.classList.remove('loading');
      button.disabled = false;

      // 更新购物车状态
      const cart = document.querySelector('cart-drawer');
      if (cart && cart.classList.contains('is-empty')) {
        cart.classList.remove('is-empty');
      }
    });
}

/**
 * 显示购物车提示
 */
function showCartToast(cartData, productData) {
  const cartToast = document.querySelector('alp-cart-toast');

  if (!cartToast) return;

  // 从API响应数据中获取产品信息
  if (cartData && cartData.items && cartData.items.length > 0) {
    const lastItem = cartData.items[cartData.items.length - 1];
            cartToast.show({
              title: lastItem.product_title,
              image: lastItem.image,
              variant: lastItem.variant_title,
              price: lastItem.final_price,
      quantity: lastItem.quantity,
            });
          } else {
    // 使用产品数据
                cartToast.show({
      title: productData.title,
      image: productData.featuredImage,
                  variant: null,
                });
  }
}

/**
 * 关闭全局弹窗
 */
function closeGlobalPopup() {
  const popup = document.getElementById('global-popup-overlay');
  if (popup) {
    // 若 STL dialog 被上推，复原位置
    const stlModal = document.querySelector('[data-shop-the-look-modal]:not([hidden])');
    if (stlModal) {
      const stlDialog = stlModal.querySelector('.shop-the-look-modal__dialog');
      if (stlDialog) {
        stlDialog.style.transform = '';
      }
    }

    popup.classList.remove('in-stl-context');
    popup.style.display = 'none';
    document.body.classList.remove('popup-open');
    document.body.style.overflow = '';
  }

  // 同步关闭桌面端内联 Quick Add
  if (typeof window.stlCloseInlineQuickAdd === 'function') {
    window.stlCloseInlineQuickAdd();
  }

  // 清空当前产品数据
  currentProductData = null;
}

// 统一的点击事件处理器（使用捕获阶段优先处理）
document.addEventListener('click', function (e) {
  // 1. 防止缺货选项被点击（最高优先级）
  if (e.target.classList.contains('color-swatch') && e.target.classList.contains('disabled')) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
  if (e.target.classList.contains('size-option-btn') && e.target.classList.contains('disabled')) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
  if (e.target.type === 'radio' && e.target.classList.contains('disabled')) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  // 2. 处理快速添加按钮点击
  const trigger = e.target.closest('.quick-add-trigger');
  if (trigger) {
    e.preventDefault();
    e.stopPropagation();

  // 从data属性读取产品数据
  try {
    const productData = {
      id: trigger.dataset.productId,
      title: trigger.dataset.productTitle,
      url: trigger.dataset.productUrl,
      variants: JSON.parse(trigger.dataset.productVariants || '[]'),
      options: JSON.parse(trigger.dataset.productOptions || '[]'),
      featuredImage: trigger.dataset.productImage,
      colorSwatches: JSON.parse(trigger.dataset.colorSwatches || '[]'),
    };

    openGlobalPopup(productData);
  } catch (error) {
    console.error('Failed to parse product data:', error);
    showNotification('Failed to load product data', 'error');
  }
    return;
  }

  // 3. 点击遮罩层关闭弹窗
  if (e.target.id === 'global-popup-overlay') {
    closeGlobalPopup();
  }
});

// ESC键关闭弹窗
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    const popup = document.getElementById('global-popup-overlay');
    if (popup && popup.style.display === 'flex') {
      closeGlobalPopup();
    }
  }
});

// Toast 弹窗函数
function showToast(message, type = 'info', duration = 3000) {
  // 创建 toast 容器（如果不存在）
  let toastContainer = document.getElementById('toast-container');
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'toast-container';
    toastContainer.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 10000;
      display: flex;
      flex-direction: column;
      gap: 10px;
      pointer-events: none;
    `;
    document.body.appendChild(toastContainer);
  }

  // 创建 toast 元素
  const toast = document.createElement('div');
  toast.className = `toast toast-${type}`;

  // 设置样式
  const baseStyles = {
    background: '#fff',
    border: '1px solid #e5e5e5',
    borderRadius: '8px',
    padding: '12px 16px',
    minWidth: '300px',
    maxWidth: '400px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    fontSize: '14px',
    lineHeight: '1.4',
    color: '#333',
    opacity: '0',
    transform: 'translateX(100%)',
    transition: 'all 0.3s ease-in-out',
    pointerEvents: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    position: 'relative',
  };

  // 根据类型设置不同的颜色
  const typeStyles = {
    success: {
      borderLeft: '4px solid #10b981',
      background: '#f0fdf4',
    },
    error: {
      borderLeft: '4px solid #ef4444',
      background: '#fef2f2',
    },
    warning: {
      borderLeft: '4px solid #f59e0b',
      background: '#fffbeb',
    },
    info: {
      borderLeft: '4px solid #3b82f6',
      background: '#eff6ff',
    },
  };

  // 应用样式
  Object.assign(toast.style, baseStyles, typeStyles[type] || typeStyles.info);

  // 添加图标
  const iconMap = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ',
  };

  const icon = document.createElement('span');
  icon.style.cssText = `
    font-size: 16px;
    font-weight: bold;
    flex-shrink: 0;
  `;
  icon.textContent = iconMap[type] || iconMap.info;
  toast.appendChild(icon);

  // 添加消息内容
  const messageEl = document.createElement('span');
  messageEl.textContent = message;
  messageEl.style.flex = '1';
  toast.appendChild(messageEl);

  // 添加关闭按钮
  const closeBtn = document.createElement('button');
  closeBtn.innerHTML = '×';
  closeBtn.style.cssText = `
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
    color: #666;
    padding: 0;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background-color 0.2s;
  `;
  closeBtn.addEventListener('click', () => removeToast(toast));
  closeBtn.addEventListener('mouseenter', () => {
    closeBtn.style.backgroundColor = '#f3f4f6';
  });
  closeBtn.addEventListener('mouseleave', () => {
    closeBtn.style.backgroundColor = 'transparent';
  });
  toast.appendChild(closeBtn);

  // 添加到容器
  toastContainer.appendChild(toast);

  // 触发动画
  requestAnimationFrame(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(0)';
  });

  // 自动移除
  const timer = setTimeout(() => {
    removeToast(toast);
  }, duration);

  // 鼠标悬停时暂停自动移除
  toast.addEventListener('mouseenter', () => {
    clearTimeout(timer);
  });

  toast.addEventListener('mouseleave', () => {
    setTimeout(() => {
      removeToast(toast);
    }, 1000);
  });

  return toast;
}

// 移除 toast 的函数
function removeToast(toast) {
  if (!toast || !toast.parentNode) return;

  toast.style.opacity = '0';
  toast.style.transform = 'translateX(100%)';

  setTimeout(() => {
    if (toast.parentNode) {
      toast.parentNode.removeChild(toast);
    }
  }, 300);
}

// 简单的通知函数
function showNotification(message, type = 'info') {
  showToast(message, type);
}

// ========== 兼容旧版本API ==========
// 保留向后兼容性
const popupProductDataMap = new Map();

function initPopupProductOptions(variants, options, triggerId) {
  console.warn('initPopupProductOptions is deprecated. Use openGlobalPopup instead.');
  if (!triggerId) return;
  popupProductDataMap.set(triggerId, {
    variants: Array.isArray(variants) ? variants : [],
    options: Array.isArray(options) ? options : [],
  });
}

function openPopup(triggerId) {
  console.warn('openPopup is deprecated. Use openGlobalPopup instead.');
  // 尝试从旧的数据映射中获取数据
  const data = popupProductDataMap.get(triggerId);
  if (data) {
    openGlobalPopup({
      id: triggerId,
      title: 'Product', // 需要从DOM中获取
      variants: data.variants,
      options: data.options 
    });
  }
}

function closePopup(triggerId) {
  console.warn('closePopup is deprecated. Use closeGlobalPopup instead.');
  closeGlobalPopup();
}
